import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import cogoToast from "cogo-toast";
import CryptoJS from "crypto-js";
import * as React from "react";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { MdAdd } from "react-icons/md";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import { FileLoader, UploadApi } from "../constants/Constants";
import {
  AWS_Access_Key_Id_Encypt,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key_Encypt,
} from "../constants/bucketCostant";
import useShortLinks from "../utilities/useShortLinks";
import CustomizedSnackbars from "./CustomizedSnackbars";
import ShortLinkNotice from "./ShortLinkNotice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide3({
  email,
  cOpen,
  setCOpen,
  cAccession,
}) {
  let Fold = email;
  const [isOpen, setIsOpen] = React.useState(false);
  const [pass, setPass] = useState("");
  // const [email, setEmail] = useState("");
  const [show, setshow] = useState(false);
  const [modal, setModal] = useState(false);
  const [date, setDate] = React.useState("");
  const [emailToSend, setEmailToSend] = React.useState("");
  const state = useSelector((state) => state.user);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const fullScreen2 = useMediaQuery(theme.breakpoints.down("lg"));
  const [urlSafeEmail, setUrlSafeEmail] = useState("");
  const [urlSafePass, setUrlSafePass] = useState("");
  const [urlSafeDate, setUrlSafeDate] = useState("");
  const [urlSafeFold, setUrlSafeFold] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [nonEditedShareData, setNonEditedShareData] = useState([]);
  const token = localStorage.getItem("token");
  const [selected, setselected] = useState(null);
  const canShareState = useSelector((state) => state.canShare);
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);
  const viewKeyImagesOnly = useSelector((state) => state.isOnlyKeyImages);
  // MRC short links (issued and resolved by the MRC backend). Always looked up by the row's
  // long share URL - never by list position - so a row can only ever get its own link.
  const shortLinks = useShortLinks({
    http: axios,
    baseUrl: UploadApi,
    token,
    folderName: Fold,
  });

  // What the read-only "link" fields show. The short link is what gets shared, so it is what is
  // displayed: a short wait notice while it is being created, and the full link only when no short
  // link could be had (the notice under the field then says why). A row that is not filled in yet
  // has no usable link at all.
  const rowIsComplete = (row) => Boolean(row?.url && row?.email && row?.pass && row?.date);
  const linkText = (row) => {
    if (!rowIsComplete(row)) return "";
    if (shortLinks.shortFor(row.url)) return shortLinks.linkFor(row.url);
    return shortLinks.isPending(row.url) ? "Creating short link…" : row.url;
  };
  const linkNotice = (row) =>
    rowIsComplete(row) ? (
      <ShortLinkNotice
        pending={shortLinks.isPending(row.url)}
        failure={shortLinks.failureFor(row.url)}
        onRetry={() => shortLinks.retry({ url: row.url, expiryDate: row.date })}
      />
    ) : null;

  const [ObjData, setObjData] = useState([
    {
      email: "",
      pass: "",
      date: "",
      url: "",
      canUpload: "",
      isKeyImagesOnly: "",
      canShare: "",
    },
  ]);

  const GetFolderShareList = async () => {
    try {
      let response = await axios.get(
        `${FileLoader}/fileloaderv1/files/GetSharedList?FolderName=${Fold}/&awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&awsbucketname=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.length > 0) {
        const transformedApiResponse =
          canShareState && FolderGet
            ? response.data
                .filter(
                  (item) =>
                    item.name != null &&
                    item.name != "null" &&
                    item.client === "true"
                )
                .map((item, index) => {
                  return {
                    email: item.name,
                    date: item.expiryDate,
                    pass: item.pass,
                    url: item.url,
                    createdAt: item.urlcreationDate,
                    updatedAt: item.urlupdateDate,
                    canUpload: item.canUpload,
                    isKeyImagesOnly: item.isKeyImagesOnly,
                    canShare: item.canShare,
                    client: item.client,
                  };
                })
            : response.data
                .filter(
                  (item) =>
                    item.name != null &&
                    item.name != "null" &&
                    item.client !== "true"
                )
                .map((item, index) => {
                  return {
                    email: item.name,
                    date: item.expiryDate,
                    pass: item.pass,
                    url: item.url,
                    createdAt: item.urlcreationDate,
                    updatedAt: item.urlupdateDate,
                    canUpload: item.canUpload,
                    isKeyImagesOnly: item.isKeyImagesOnly,
                    canShare: item.canShare,
                    client: item.client,
                  };
                });
        setObjData(transformedApiResponse);
        setNonEditedShareData(transformedApiResponse);

        // Remember the short links stored with the entries, and look up / create the missing
        // ones for the rows being shown. Keyed by long URL: the rows above are a FILTERED view
        // of response.data, so an index into one list is not an index into the other.
        shortLinks.seed(
          response.data
            .filter((item) => item && typeof item === "object" && item.url)
            .map((item) => ({
              url: item.url,
              shortCode: item.shortCode,
              shortUrl: item.shortUrl,
            }))
        );
        shortLinks.ensure(
          transformedApiResponse
            .filter((row) => row.url && row.pass && row.date)
            .map((row) => ({ url: row.url, expiryDate: row.date }))
        );
      } else {
        setObjData([
          {
            email: "",
            pass: "",
            date: "",
            url: "",
          },
        ]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (Fold !== "") {
      GetFolderShareList();
    }
  }, [Fold]);

  // let ArrayForRender=[1,1];

  // const onChangeField = (e) => {
  //   setObjData()
  // };
  // //console.log(ObjData, "ObjData");

  // const onChangeField = (index, field, value) => {
  //   const updatedObjData = [...ObjData];
  //   updatedObjData[index] = {
  //     ...updatedObjData[index],
  //     [field]: value,
  //   };
  //   setObjData(updatedObjData);
  // };
  // const onChangeField = (event, i) => {
  //   const value = event.target.value;
  //   const name = event.target.name;
  //   const prevData = [...ObjData];  // Create a new array with the same elements

  //   // Create a new object based on the current element at index i and update the property [name] with the new value
  //   prevData[i] = {
  //     ...prevData[i],
  //     [name]: value
  //   };

  //   // Set the updated array as the new state
  //   setObjData(prevData);
  // };

  const onChangeField = (event, i) => {
    const value = event.target.value;
    const name = event.target.name;
    const type = event.target.type;
    const prevData = [...ObjData];
    let encryptedEmail = "";
    let encryptedPass = "";
    let encryptedDate = "";
    let encryptedFolder = "";

    const valueUpload = prevData[i].canUpload;
    const valueKeyImages = prevData[i].isKeyImagesOnly;
    const valueShare = prevData[i].canShare;
    let urlSafeValue = "";
    let urlSafeKeyImages = "";
    let urlSafeShare = "";
    if (
      valueUpload == undefined ||
      valueUpload == "" ||
      valueUpload == "notofileupload"
    ) {
      if (name == "canUpload") {
        const encryptedValue = CryptoJS.AES.encrypt(
          "yestofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "canUpload") {
        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedValue = CryptoJS.AES.encrypt(
          "yestofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    }

    if (viewKeyImagesOnly) {
      const encryptedImages = CryptoJS.AES.encrypt(
        "onlykeyimages",
        secretKey
      ).toString();
      urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
    } else if (
      valueKeyImages == undefined ||
      valueKeyImages == "" ||
      valueKeyImages == "allimages"
    ) {
      if (name == "onlyKeyImages") {
        const encryptedImages = CryptoJS.AES.encrypt(
          "onlykeyimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");

        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedImages = CryptoJS.AES.encrypt(
          "allimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "onlyKeyImages") {
        const encryptedImages = CryptoJS.AES.encrypt(
          "allimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
      } else {
        const encryptedImages = CryptoJS.AES.encrypt(
          "onlykeyimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");

        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    }

    if (
      valueShare == undefined ||
      valueShare == "" ||
      valueShare == "noshare"
    ) {
      if (name == "canShare") {
        const encryptedShares = CryptoJS.AES.encrypt(
          "yesshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      } else {
        const encryptedShares = CryptoJS.AES.encrypt(
          "noshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "canShare") {
        const encryptedShares = CryptoJS.AES.encrypt(
          "noshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      } else {
        const encryptedShares = CryptoJS.AES.encrypt(
          "yesshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      }
    }

    if (type == "password" || type == "text") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      encryptedPass = CryptoJS.AES.encrypt(value, secretKey).toString();
      let urlSafePass = encryptedPass.replace(/\//g, "bbbb");
      setUrlSafePass(urlSafePass);
      prevData[i] = {
        ...prevData[i],
        [name]: value,
        email: Fold,
        url: `${window.origin}/signin/${urlSafefold}/${urlSafePass}/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (type == "date") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(value, secretKey).toString();
      let urlSafeDate = encryptedDate.replace(/\//g, "bbbb");
      setUrlSafeDate(urlSafeDate);
      prevData[i] = {
        ...prevData[i],
        [name]: value,
        url: `${window.origin}/signin/${urlSafefold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${urlSafeDate}/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "canUpload") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["canUpload"]:
          valueUpload === "yestofileupload"
            ? "notofileupload"
            : "yestofileupload",
        url: `${window.origin}/signin/${urlSafefold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "onlyKeyImages") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["isKeyImagesOnly"]:
          valueKeyImages === "onlykeyimages" ? "allimages" : "onlykeyimages",
        ["canUpload"]:
          valueKeyImages === "onlykeyimages"
            ? "notofileupload"
            : prevData[i].canUpload,
        url: `${window.origin}/signin/${urlSafefold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "canShare") {
      encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      setUrlSafeEmail(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["canShare"]: valueShare === "yesshare" ? "noshare" : "yesshare",
        url: `${window.origin}/signin/${urlSafefold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    // Update the URL-safe variables

    // Update the specific field with the new value

    // Set the updated array and URL-safe variables as the new state

    // The long URL of this row just changed. Its short link is created once the user pauses
    // (debounced per row) - not on every keystroke - and is looked up by this URL.
    if (prevData[i]?.pass && prevData[i]?.date && prevData[i]?.url) {
      shortLinks.schedule(i, {
        url: prevData[i].url,
        expiryDate: prevData[i].date,
      });
    } else {
      shortLinks.cancel(i);
    }
    setObjData(prevData);
  };

  const SendEmail = async () => {
    try {
      let fromdata = new FormData();

      // Send the MRC short link; if the service is unavailable the full link still works.
      let newselectedurl = selected?.url;
      try {
        const ensured = await shortLinks.ensure([
          { url: selected?.url, expiryDate: selected?.date },
        ]);
        newselectedurl = ensured.get(selected?.url)?.shortUrl || selected?.url;
      } catch (error) {
        newselectedurl = selected?.url;
      }

      fromdata.append("address", emailToSend);
      fromdata.append("subject", " Sharing Study");
      fromdata.append(
        "link",
        `${newselectedurl}\n` + `\nPassword:${selected?.pass}`
      );
      // fromdata.append("userID", `${selected?.email}`);
      fromdata.append("userPass", `${selected?.pass}`);
      const axiosInstance = axios.create({
        baseURL: `${UploadApi}/user/`,
      });
      axiosInstance
        .post("sendEmailLink", fromdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (response) => {
          cogoToast.success("Mail send Successfully.", {
            position: "top-right",
          });
          setModal(false);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const ShareFolderLink = async (e, i) => {
    // Make sure this link's short link exists so it is saved together with the entry. No-op when
    // it is already known; if the service is unavailable the entry is simply saved without it.
    const ensured = await shortLinks.ensure([
      { url: e?.url, expiryDate: e?.date },
    ]);
    const shortLink = ensured.get(e?.url) || null;

    let formData = new FormData();
    formData.append("awsAccessKeyId", AWS_Access_Key_Id_Encypt());
    formData.append("awsSecretAccessKey", AWS_Secret_Access_Key_Encypt());
    formData.append(`AccountDetail[0].Name`, e?.email);
    formData.append(`AccountDetail[0].expiryDate`, e?.date);
    formData.append(`AccountDetail[0].password`, e?.pass);
    formData.append(`AccountDetail[0].url`, e?.url);
    formData.append(`AccountDetail[0].canUpload`, e?.canUpload);
    formData.append(`AccountDetail[0].isKeyImagesOnly`, e?.isKeyImagesOnly);
    formData.append(`AccountDetail[0].canShare`, e?.canShare);
    formData.append(`AccountDetail[0].urlCreationDate`, e?.createdAt);
    if (shortLink) {
      formData.append(`AccountDetail[0].ShortCode`, shortLink.shortCode);
      formData.append(`AccountDetail[0].ShortUrl`, shortLink.shortUrl);
    }
    formData.append(
      `AccountDetail[0].client`,
      canShareState && FolderGet ? true : false
    );
    formData.append("awsbucketname", AWS_Bucket_Name());
    formData.append("Region", AWS_Region());

    if (nonEditedShareData.length > 0) {
      if (
        e?.createdAt != null &&
        e?.createdAt != undefined &&
        nonEditedShareData[i]?.createdAt != null &&
        nonEditedShareData[i]?.createdAt != undefined &&
        e.createdAt === nonEditedShareData[i].createdAt
      ) {
        formData.append(`AccountDetail[0].urlUpdateDate`, "yes");
      }
    }
    let requestBody;

    try {
      let response = await axios.post(
        `${FileLoader}/fileloaderv1/files/ShareFolder?FolderName=${Fold}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && nonEditedShareData.length > 0) {
        if (
          e?.createdAt != null &&
          e?.createdAt != undefined &&
          nonEditedShareData[i]?.createdAt != null &&
          nonEditedShareData[i]?.createdAt != undefined &&
          e.createdAt === nonEditedShareData[i].createdAt
        ) {
          // Re-saving an unchanged link only drops its superseded copy.
          RemoveSharePerson(
            nonEditedShareData[i],
            i,
            nonEditedShareData[i].url === e?.url
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // A row counts as "edited" when any shareable field differs from what was loaded
  // (nonEditedShareData). Any real edit regenerates this row's url, so comparing url (plus the
  // explicit fields) reliably tells an edit apart from an untouched copy. Copy to clipboard uses
  // this to persist ONLY when something changed; an unchanged row is copied, never re-saved.
  const isRowEdited = (e, i) => {
    const base = nonEditedShareData[i];
    if (!base) return true; // newly added row with no baseline -> needs saving
    return (
      e?.url !== base.url ||
      e?.pass !== base.pass ||
      e?.date !== base.date ||
      e?.canUpload !== base.canUpload ||
      e?.isKeyImagesOnly !== base.isKeyImagesOnly ||
      e?.canShare !== base.canShare
    );
  };

  const saveCredentials = (args) => {
    var data = [];
    if (!localStorage.getItem("dcmCredentails")) {
      data.push(args);
      localStorage.setItem("dcmCredentails", JSON.stringify(data));
    } else {
      data = JSON.parse(localStorage.getItem("dcmCredentails"));
      var filteredData = data.filter((e) => {
        if (e.accession !== args.accession) {
          return e;
        }
      });
      filteredData.push(args);
      localStorage.setItem("dcmCredentails", JSON.stringify(filteredData));
    }
  };

  const ShareData = () => {};

  const AddSharePerson = () => {
    const newObj = {
      email: "",
      pass: "",
      date: "",
    };
    setObjData([...ObjData, newObj]);
  };

  const RemoveSharePerson = async (e, i, onlyThisRecord = false) => {
    // Deletes this exact link only. Deleting by name removed the first link of
    // the folder instead, which was usually the master link.
    try {
      await axios.post(
        `${UploadApi}/apiUpload/delete-share-link`,
        {
          bucketName: AWS_Bucket_Name(),
          Region: AWS_Region(),
          folderName: Fold,
          url: e?.url,
          onlyThisRecord,
          createdAt: e?.createdAt,
          updatedAt: e?.updatedAt,
          clientOnly: canShareState && FolderGet ? true : false,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {}
    shortLinks.cancel(i); // a removed row must not create a short link later
    const newArrayForRender = [...ObjData]; // Create a copy of the array
    newArrayForRender.splice(i, 1); // Remove one element at the specified index

    setObjData(newArrayForRender);
    GetFolderShareList();
  };

  const secretKey = "your-secret-key"; // Replace with your secret key

  const encodeBase64UrlSafe = (input) => {
    return btoa(input)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  const encryptedEmail = CryptoJS.AES.encrypt(email, secretKey).toString();
  const encryptedPass = CryptoJS.AES.encrypt(pass, secretKey).toString();
  const encryptedDate = CryptoJS.AES.encrypt(date, secretKey).toString();

  // let urlSafeFolderName= encryptedFolderName.replace(/\//g, "bbbb");
  // let urlSafeEmail = encryptedEmail.replace(/\//g, "bbbb");
  // let urlSafePass = encryptedPass.replace(/\//g, "bbbb");
  // let urlSafeDate = encryptedDate.replace(/\//g, "bbbb");
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  // Short links live in useShortLinks, keyed by the long URL. (They used to be kept in an
  // array indexed by row position, which could hand a row the link of a different entry.)

  const formatDateTime = (isoDateStr) => {
    try {
      const dateObj = new Date(isoDateStr);

      // Format date as YYYY-MM-DD
      const datePart = dateObj.toISOString().split("T")[0];

      // Format time as h:mm AM/PM
      const hours = dateObj.getHours();
      const minutes = dateObj.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedHour = hours % 12 || 12; // Convert 0 -> 12 for 12 AM
      const timePart = `${formattedHour}:${minutes} ${ampm}`;

      return "\t" + datePart + "\t" + timePart;
    } catch (error) {
      console.error(error);
      return "";
    }
  };

  return (
    <>
      <Dialog
        open={cOpen}
        onClose={() => setCOpen(false)}
        TransitionComponent={Transition}
        aria-describedby="alert-dialog-slide-description"
        fullScreen={fullScreen}
        PaperProps={{
          // style: {
          //   width: "70%",
          //   //   border: '1px solid white',
          // },
          sx: {
            width: { xs: "77%", sm: "57%", md: "none" },
            height: { xs: "77%", sm: "77%", md: "46%" },
            maxHeight: {
              xs: "none",
              sm: "calc(100% - 64px)",
              md: "calc(100% - 64px)",
            },
            maxWidth: { xs: "100%", sm: "none", md: "600px" },
          },
        }}
      >
        <DialogTitle
          sx={{
            // marginLeft: 5,
            display: "flex",
            flexDirection: { xs: "row", sm: "row" }, // Column on mobile, row on larger screens
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: { xs: "small", sm: "small", md: "la" },
            gap: 1, // Adds spacing between buttons in column mode
          }}
        >
          {"Share folders"}{" "}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "row", sm: "row" },
              gap: 1,
            }}
          >
            <Button
              onClick={AddSharePerson}
              variant="contained"
              className="float-right flex "
            >
              {" "}
              <MdAdd />
              ADD
            </Button>
            {/* <span
            style={{
              cursor: "pointer",
            }}
            onClick={AddSharePerson}
            className="float-right flex "
          >
           
            ADD
          </span> */}
            <Button
              className="float-right flex "
              onClick={() => {
                setCOpen(false);
                // setshow(false);
                // setObjData([
                //   {
                //     email: "",
                //     pass: "",
                //     date: "",
                //     url: "",
                //   },
                // ]);
                // setPass("");
                // setDate("");
                // setArrayForRender([1]);
              }}
            >
              Back
            </Button>
          </Box>
        </DialogTitle>
        {/* {Both()} */}

        {ObjData?.map((e, i) => {
          return (
            <div className="mrc-single-share">
              <DialogContent
                // style={{ overflow: "hidden", marginLeft: 5 }}
                sx={{
                  overflowX: "hidden",
                  marginLeft: { xs: 0, sm: 0, md: 0 },
                  padding: {
                    xs: "0px 11px",
                    sm: "0px 24px;",
                    md: "5px 24px;",
                  },
                }}
              >
                <DialogContentText id="alert-dialog-slide-description">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {e?.createdAt && (
                      <div>
                        Share URL created at:
                        {formatDateTime(e?.createdAt) || "N/A"}
                      </div>
                    )}
                    {e?.updatedAt &&
                      e?.updatedAt != "" &&
                      e?.updatedAt != "undefined" && (
                        <div>
                          Updated At:
                          {formatDateTime(e?.updatedAt) || "N/A"}
                        </div>
                      )}
                    <div
                      // style={{
                      //   display: "flex",
                      //   flexDirection: "row",
                      //   width: "540px",
                      // }}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: { xs: "289px", sm: "540px", md: "540px" },
                      }}
                    >
                      <OutlinedInput
                        margin="normal"
                        required
                        fullWidth
                        label={"link"}
                        variant="outlined"
                        value={linkText(e)}
                        placeholder="Enter case ID, password and expiry date to create the link"
                        inputProps={{ "aria-label": "Share link" }}
                        disabled={true}
                      />
                    </div>
                    {linkNotice(e)}
                    <hr />
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        marginTop: "-35px",
                        flexDirection: {
                          xs: "column",
                          sm: "column",
                          md: "row",
                        },
                      }}
                    >
                      {/* <Grid item xs={4}>
                        <br />
                        <TextField
                          hiddenLabel
                          label="User Name"
                          variant="outlined"
                          size="small"
                          // disabled={true}
                          type={"email"}
                          value={e.email}
                          onChange={(event) => {
                            // setEmail(e.target.value);
                            onChangeField(event, i);
                          }}
                          name="email"
                          // onChange={(e) => {setEmail(e.target.value);onChangeField(e)}}
                          style={{
                            borderRadius: "3px",
                            backgroundColor: "white",
                            width: 190,
                          }}
                        />
                      </Grid> */}
                      <Grid item xs={6} style={{ paddingLeft: 23 }}>
                        <br />
                        <TextField
                          autocomplete="new-password"
                          hiddenLabel
                          label="password"
                          variant="outlined"
                          size="small"
                          type={showPassword ? "text" : "password"}
                          // value={pass}
                          name="pass"
                          value={e.pass}
                          onChange={(event) => {
                            setDate(event.target.value);
                            onChangeField(event, i);
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleTogglePassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          style={{
                            borderRadius: "3px",
                            backgroundColor: "white",
                            width: 250,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} style={{ paddingLeft: 10 }}>
                        <br />
                        <TextField
                          label="Expire Date"
                          InputLabelProps={{ shrink: true, required: true }}
                          variant="outlined"
                          size="small"
                          // value={date}
                          onChange={(event) => {
                            // setEmail(e.target.value);
                            onChangeField(event, i);
                          }}
                          type="date"
                          value={e.date}
                          min={
                            new Date().toISOString().substr(0, 19).split("T")[0]
                          }
                          style={{ borderRadius: "3px", width: 250 }}
                          name="date"
                        />
                      </Grid>
                    </Grid>
                  </div>
                </DialogContentText>
              </DialogContent>
              <div className="flex w-full items-center pl-4 p-1 group rounded text-dark">
                {!canShareState && (
                  <>
                    <input
                      id={`checkbox-item-${i}`}
                      type="checkbox"
                      name="canUpload"
                      checked={e?.canUpload == "yestofileupload"}
                      value={e?.canUpload == "yestofileupload"}
                      className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                      onChange={(event) => {
                        onChangeField(event, i);
                      }}
                      disabled={e?.isKeyImagesOnly == "onlykeyimages"}
                      defaultChecked={e?.canUpload == "yestofileupload"} // Check if the folder is in selectedFolders
                    />
                    <label
                      htmlFor={`checkbox-item-${i}`}
                      className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                    >
                      Allow file upload
                    </label>
                  </>
                )}
                {!viewKeyImagesOnly && (
                  <>
                    <input
                      id={`checkbox-keyimages-${i}`}
                      type="checkbox"
                      name="onlyKeyImages"
                      checked={e?.isKeyImagesOnly == "onlykeyimages"}
                      value={e?.isKeyImagesOnly == "onlykeyimages"}
                      className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                      onChange={(event) => {
                        onChangeField(event, i);
                      }}
                      defaultChecked={e?.isKeyImagesOnly == "onlykeyimages"} // Check if the folder is in selectedFolders
                    />
                    <label
                      htmlFor={`checkbox-keyimages-${i}`}
                      className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                    >
                      Only Key Images
                    </label>
                  </>
                )}

                {!canShareState && (
                  <>
                    <input
                      id={`checkbox-sharing-${i}`}
                      type="checkbox"
                      name="canShare"
                      checked={e?.canShare == "yesshare"}
                      value={e?.canShare == "yesshare"}
                      className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                      onChange={(event) => {
                        onChangeField(event, i);
                      }}
                      defaultChecked={e?.canShare == "yesshare"} // Check if the folder is in selectedFolders
                    />
                    <label
                      htmlFor={`checkbox-sharing-${i}`}
                      className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                    >
                      Allow File Sharing
                    </label>
                  </>
                )}
              </div>

              <DialogActions
                sx={{
                  marginBottom: "10px",
                  justifyContent: "center",
                  display: "flex",
                  flexWrap: "wrap", // Allow buttons to wrap on small screens
                  gap: 1, // Adds spacing between buttons
                  flexDirection: { xs: "row", sm: "row", md: "row", lg: "row" }, // Default to row
                  "& > *": { flex: { xs: "1 1 calc(50% - 8px)", md: "unset" } }, // 2 per row on mobile, all in 1 row on large screens
                }}
              >
                {/* Email button 
                {!canShareState && (
                  <Button
                    variant="contained"
                    disabled={e?.email && e?.pass && e?.date ? false : true}
                    onClick={() => {
                      setModal(true);
                      ShareFolderLink(e, i);
                      setselected(e);
                      // onClick={() =>
                      // SendEmail();
                    }}
                    // style={{ flex: "1 1 45%" }}
                    sx={{
                      fontSize: { xs: "xx-small", sm: "small", md: "small" },
                    }}
                  >
                    Send via email
                  </Button>
                )}
*/}
                {/* Back button  */}

                <Button
                  onClick={() => {
                    RemoveSharePerson(e, i);
                  }}
                  // style={{ flex: "1 1 45%" }}
                  sx={{
                    fontSize: { xs: "xx-small", sm: "small", md: "small" },
                  }}
                >
                  Remove
                </Button>

                {/* QR button */}
                {!canShareState && (
                  <Button
                    disabled={e?.email && e?.pass && e?.date ? false : true}
                    onClick={() => {
                      setshow(!show);

                      ShareFolderLink(e, i);
                    }}
                    // style={{ flex: "1 1 45%" }}
                    sx={{
                      fontSize: { xs: "xx-small", sm: "small", md: "small" },
                    }}
                  >
                    Share QR Code
                  </Button>
                )}

                {/* QR code  */}
                {show && (
                  <QRCode
                    size={256}
                    bgColor="#000000"
                    fgColor="#ffffff"
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      width: "15%",
                    }}
                    value={shortLinks.linkFor(e?.url)}
                    viewBox={`256 256 256 256`}
                  />
                )}

                {/* copy to clipboard */}
                <CopyToClipboard
                  text={shortLinks.linkFor(e?.url)}
                  // onClick={()=> {ShareFolderLink(e);}}
                >
                  <Button
                    variant="contained"
                    onClick={() => {
                      // Only persist when this row was actually edited (date/password/toggles);
                      // an untouched row is just copied, so the URL and "Updated At" stay the same.
                      if (isRowEdited(e, i)) {
                        ShareFolderLink(e, i);
                      }
                      setIsOpen(true);
                      ShareData();
                      setTimeout(() => {
                        setIsOpen(false);
                      }, 2000);
                      saveCredentials({
                        accession: cAccession,
                        link: `${e?.url}/`,
                        CaseID: e?.email,
                        pass: e?.pass,
                      });
                    }}
                    disabled={
                      e?.email && e?.pass && e?.date
                        ? shortLinks.isPending(e?.url)
                        : true
                    }
                    // style={{ flex: "1 1 45%" }}
                    sx={{
                      fontSize: { xs: "xx-small", sm: "small", md: "small" },
                    }}
                  >
                    Copy to clipboard
                  </Button>
                </CopyToClipboard>
              </DialogActions>
            </div>
          );
        })}

        {/* {ArrayForRender.map((key, value) => Both(value))} */}
        <CustomizedSnackbars
          isOpen={isOpen}
          severity={"success"}
          message={"Credentials copied to clipboard"}
        />
      </Dialog>

      <Dialog
        open={modal}
        // TransitionComponent={Transition}
        TransitionComponent={Transition}
        style={{ height: "100%" }}
        PaperProps={{
          style: {
            height: "70%",
            //   border: '1px solid white',
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ overflow: "hidden", marginLeft: 5 }}>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "540px",
                }}
              >
                <OutlinedInput
                  margin="normal"
                  required
                  fullWidth
                  label={"link"}
                  variant="outlined"
                  // value={`${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}`}
                  value={linkText(selected)}
                  inputProps={{ "aria-label": "Share link" }}
                  disabled={true}
                />
              </div>
              {linkNotice(selected)}
              <hr />
              <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                {/* <Grid item xs={4} >
                                  
                                    
                                <br/>
                                    <TextField hiddenLabel label='Case ID'  variant='outlined' disabled={true} size="small" type={"email"} value={email}  style={{ borderRadius: "3px" , backgroundColor:'white',width:190}} />
                                </Grid> */}
                <Grid item lg={12} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="Email"
                    variant="outlined"
                    size="small"
                    type={"email"}
                    value={emailToSend}
                    onChange={(e) => setEmailToSend(e.target.value)}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 500,
                    }}
                  />
                </Grid>
                <Grid item lg={12} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="Subject"
                    variant="outlined"
                    size="small"
                    type={"text"}
                    value={"Sharing Study"}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 500,
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
          {/* <Button variant="contained" disabled={email && pass && date ? false : true} onClick={()=>setModal(true)} >Share with email</Button> */}
          <Button
            onClick={() => {
              setModal(false);
              setObjData([
                {
                  email: "",
                  pass: "",
                  date: "",
                  url: "",
                },
              ]);
            }}
          >
            Back
          </Button>
          <Button variant="contained" onClick={() => SendEmail()}>
            Send Email
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
